<template>
  <v-dialog
    v-model="localShow"
    max-width="400px"
    persistent
    content-class="status-modal-dialog"
  >
    <v-card class="status-modal-card" :class="success ? 'status-modal-card--success' : 'status-modal-card--error'">
      <div class="status-modal__icon-wrap">
        <div class="status-modal__icon-circle" :class="success ? 'status-modal__icon-circle--success' : 'status-modal__icon-circle--error'">
          <v-icon size="36" color="white">
            {{ success ? 'mdi-check' : 'mdi-close' }}
          </v-icon>
        </div>
      </div>

      <v-card-text class="text-center px-8 pb-6 pt-2">
        <h3 class="status-modal__title mb-2" :class="success ? 'status-modal__title--success' : 'status-modal__title--error'">
          {{ success ? 'Успешно' : 'Ошибка' }}
        </h3>
        <p class="status-modal__message mb-0">{{ message }}</p>
      </v-card-text>

      <v-card-actions class="justify-center pb-6 pt-0">
        <v-btn
          depressed
          height="40"
          class="px-10"
          :color="success ? '#009E60' : '#EC2E2E'"
          dark
          style="border-radius: 8px; font-weight: 600;"
          @click="close"
        >
          Понятно
        </v-btn>
      </v-card-actions>

      <div class="status-modal__progress" :class="success ? 'status-modal__progress--success' : 'status-modal__progress--error'">
        <div class="status-modal__progress-bar" :style="{ animationDuration: duration + 'ms' }"></div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'StatusModal',
  model: { prop: 'show', event: 'update:show' },
  props: {
    show: { type: Boolean, default: false },
    success: { type: Boolean, default: true },
    message: { type: String, default: '' },
    duration: { type: Number, default: 4000 },
  },
  data() {
    return {
      localShow: false,
      timer: null,
    };
  },
  watch: {
    show(val) {
      this.localShow = val;
      if (val) {
        this.startTimer();
      } else {
        this.clearTimer();
      }
    },
    localShow(val) {
      if (!val) this.close();
    },
  },
  methods: {
    startTimer() {
      this.clearTimer();
      this.timer = setTimeout(() => this.close(), this.duration);
    },
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    close() {
      this.clearTimer();
      this.localShow = false;
      this.$emit('update:show', false);
      this.$emit('close');
    },
  },
  beforeDestroy() {
    this.clearTimer();
  },
};
</script>

<style lang="scss">
.status-modal-dialog {
  border-radius: 16px !important;
}

.status-modal-card {
  border-radius: 16px !important;
  overflow: hidden;
  padding-top: 32px;
  position: relative;

  &--success {
    border-top: 4px solid #009E60;
  }
  &--error {
    border-top: 4px solid #EC2E2E;
  }
}

.status-modal__icon-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.status-modal__icon-circle {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &--success {
    background: linear-gradient(135deg, #009E60, #00c97b);
    box-shadow: 0 8px 24px rgba(0, 158, 96, 0.3);
  }
  &--error {
    background: linear-gradient(135deg, #EC2E2E, #ff5757);
    box-shadow: 0 8px 24px rgba(236, 46, 46, 0.3);
  }
}

.status-modal__title {
  font-size: 20px;
  font-weight: 700;

  &--success { color: #009E60; }
  &--error   { color: #EC2E2E; }
}

.status-modal__message {
  font-size: 14px;
  color: #6B759A;
  line-height: 1.5;
}

.status-modal__progress {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: #f0f0f0;

  &--success .status-modal__progress-bar { background: #009E60; }
  &--error   .status-modal__progress-bar { background: #EC2E2E; }
}

.status-modal__progress-bar {
  height: 100%;
  width: 100%;
  animation: progressShrink linear forwards;
  transform-origin: left;
}

@keyframes progressShrink {
  from { transform: scaleX(1); }
  to   { transform: scaleX(0); }
}
</style>
